import BasicContentHorizontalImageSplitHero from './BasicContentHorizontalImageSplitHero';

export { type BasicContentHorizontalImageSplitHeroProps } from './BasicContentHorizontalImageSplitHero';
export default BasicContentHorizontalImageSplitHero;
